import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount } from "@nosto/preact"
import { useEffect, useState } from 'preact/hooks'
import Icon from "./elements/Icon"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar({ lableFor }) {
    const { loading, query, response, pageType } = useAppState()
    const selectedFiltersCount = useSelectedFiltersCount()

    const docCount = response.products?.total ?? 0
    const [isSticked, setIsSticked] = useState(false)
    const totalSummary = pageType === "category" ? `${document.querySelector(".nosto_category .category_string").innerText}` : `Results for "${query.query}"`
    const borderWrapperClassNames = isSticked ? 'border-and-shadow-wrapper sticked' : 'border-and-shadow-wrapper'



    useEffect(() => {
        const handleScroll = () => {
            setIsSticked(window.scrollY >= 117)
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll() // initial run

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <>
            <div className="container">
                {!loading && pageType === "category" && (
                    <div class="breadcrumbs">
                        <a href="/collections/all">Home</a> /
                        <span>&nbsp;{document.querySelector(".nosto_category .category_string").innerText}</span>
                    </div>
                )}
                <div
                    className="collection-header heading-3"
                    style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
                >
                    {!loading && (
                        <span
                            class="ns-d-inline ns-text-align-left ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-left ns-color-black heading-4"
                            data-nosto-element="totalResults"
                        >
                            {totalSummary}
                        </span>
                    )}
                    {/* <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                        <ToggleMobileSidebarButton
                            lableFor={lableFor}
                            selectedFiltersCount={selectedFiltersCount}
                        />
                    </div> */}
                </div>
            </div>

            <div data-selected-filters={selectedFiltersCount} className={borderWrapperClassNames}>
                <div className="collection-results--filter container">
                    {/* <span class="ns-color-black heading-5" style="margin-bottom:0!important;">Filters & Sort</span> */}
                    <button data-open-filters="" aria-label="Open filters">
                        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Filter Icon">
                                <path id="Vector 1" d="M0 3.5H20" stroke="#313133" stroke-width="1.43"></path>
                                <path id="Vector 1_2" d="M0 13.5H20" stroke="#313133" stroke-width="1.43"></path>
                                <circle id="Ellipse 52" cx="5" cy="3.5" r="2.285" fill="white" stroke="#313133" stroke-width="1.43"></circle>
                                <circle id="Ellipse 52_2" cx="15" cy="13.5" r="2.285" fill="white" stroke="#313133" stroke-width="1.43"></circle>
                            </g>
                        </svg>
                        <span data-selected-filters-count-wrapper>
                        Filters

                        {selectedFiltersCount > 0 && (
                            <span data-selected-filters-count className="ns-pl-1">
                                ({selectedFiltersCount})
                            </span>
                        )}
                        <span className="ns-pl-1">&amp; Sort</span>
                    </span>
                    </button>
                    <span class="result-count">{docCount} results</span>
                    {/* <label class="ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3" for="toggle-mobile-sidebar">
                        <i class="ns-icon ns-icon-close "></i>
                    </label> */}
                </div>

            </div>
        </>
    )
}